export function addDistinct<T>(array: T[], value: T | T[]): T[] {
  const set = new Set<T>(array);
  if (Array.isArray(value)) {
    for (const thisValue of value) {
      set.add(thisValue);
    }
  } else {
    set.add(value);
  }
  return Array.from(set);
}
